import
{
    SET_EVENT_IMAGE,
    SET_ONLINE,
    SET_RANKING,
    SET_LOADING,
    SET_DOWNLOAD_LINK,
    SET_SERVER_INFO,
    SET_EVENTS,
    SET_DONATION_DETAILS,
    SET_SHOW_ONLINE
} from './types.js'
import axios from 'axios'

export default {
  setImageEvent({ commit }, payload) {
      commit(SET_EVENT_IMAGE, payload)
  },
  setRanking({ commit }, payload) {
      commit(SET_RANKING, payload)
  },
  setOnline({ commit }, payload) {
      commit(SET_ONLINE, payload)
  },
  setLoading({ commit }, payload) {
      commit(SET_LOADING, payload)
  },
  setDownloadLinks({ commit }, payload) {
    commit(SET_DOWNLOAD_LINK, payload)
  },
  setServerInfo({ commit }, payload) {
    commit(SET_SERVER_INFO, payload)
  },
  setEvents({ commit }, payload) {
    commit(SET_EVENTS, payload)
  },
  setDonationInfo({ commit }, payload) {
    commit(SET_DONATION_DETAILS, payload)
  },
  setShowOnline ({ commit }, payload) {
    commit(SET_SHOW_ONLINE, payload)
  },
  async getInitialData (state) {
      state.dispatch('setLoading', true)
    await axios.get('/api/initialdata')
      .then(async response => {
          state.dispatch('setImageEvent', response.data.data.event_image)
          state.dispatch('setRanking', response.data.data.ranking)
          state.dispatch('setOnline', response.data.data.online)
          state.dispatch('setDownloadLinks', response.data.data.links)
          state.dispatch('setServerInfo', response.data.data.server_info)
          state.dispatch('setEvents', response.data.data.events)
          state.dispatch('setDonationInfo', response.data.data.donation_info)
          state.dispatch('setShowOnline', response.data.data.show_online)
          state.dispatch('setLoading', false)
          return Promise.resolve(response)
      })
      .catch(async error => {
          state.dispatch('setLoading', false)
          return Promise.reject(error)
      })
  },
  async requestAddEventImage (state, parameters) {
    return axios.post('/api/event/add-event-image', parameters)
      .then(response => {
          return Promise.resolve(response)
      })
      .catch(error => {
          return Promise.reject(error)
      })
  },
  async requestDeleteEventImage (state, imageID) {
    return axios.delete(`/api/event/${imageID}`)
      .then(response => {
          return Promise.resolve(response)
      })
      .catch(error => {
          return Promise.reject(error)
      })
  },
  async requestUpdateEventImage (state, parameters) {
    return axios.post(`/api/event/update/${parameters.ID}`, parameters)
      .then(response => {
          return Promise.resolve(response)
      })
      .catch(error => {
          return Promise.reject(error)
      })
  },
  async requestAddDownloadLink (state, parameters) {
    return axios.post(`/api/download/add`, parameters)
      .then(response => {
          return Promise.resolve(response)
      })
      .catch(error => {
          return Promise.reject(error)
      })
  },
  async requestAddServerInfo (state, parameters) {
    return axios.post(`/api/settings/server-info`, parameters)
      .then(response => {
          return Promise.resolve(response)
      })
      .catch(error => {
          return Promise.reject(error)
      })
  },
  async requestAddEvents (state, parameters) {
    return axios.post(`/api/event/add-event`, parameters)
      .then(response => {
          return Promise.resolve(response)
      })
      .catch(error => {
          return Promise.reject(error)
      })
  },
  async requestUpdateEvents (state, parameters) {
    return axios.post(`/api/event/update-event/${parameters.ID}`, parameters)
      .then(response => {
          return Promise.resolve(response)
      })
      .catch(error => {
          return Promise.reject(error)
      })
  },
  async requestDeleteEvents (state, id) {
    return axios.delete(`/api/event/delete-event/${id}`)
      .then(response => {
          return Promise.resolve(response)
      })
      .catch(error => {
          return Promise.reject(error)
      })
  },
  async requestAddDonationDetails (state, parameters) {
    return axios.post('/api/settings/donation-info', parameters)
      .then(response => {
          return Promise.resolve(response)
      })
      .catch(error => {
          return Promise.reject(error)
      })
  },
  async requestDeleteDonationDetails (state, ID) {
    return axios.delete(`/api/settings/donation-info/${ID}`)
      .then(response => {
          return Promise.resolve(response)
      })
      .catch(error => {
          return Promise.reject(error)
      })
  },
}